import axios from "axios";

const fetchBillsWithExecutiveAction = async (billsData) => {
  const limit = 150;
  let executiveData = [];
  let currentPage = 0;
  let totalPages = 1;
  try {
    while (currentPage < totalPages) {
      const billIds = billsData.map(bill => bill.id);
      const executiveActionResponse = await axios.post(
          `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1//executiveActions/search?limit=${limit}&offset=${currentPage}`, {
            billIds: billIds
          }
      );

      const executiveActionData = executiveActionResponse.data;
      executiveData = executiveData.concat(executiveActionData.content || []);
      totalPages = executiveActionData.totalPages;
      currentPage++;
    }

    const sortedExecutiveActionData = executiveData.length
        ? executiveData.sort(
            (a, b) =>
                new Date(a.standingCommitteeMeeting.meetingTime) -
                new Date(b.standingCommitteeMeeting.meetingTime)
        )
        : [];

    return billsData.map(bill => ({
      ...bill,
      executiveAction: sortedExecutiveActionData.filter(execAction => execAction.billId === bill.id) || [],
    }));
  } catch (error) {
      console.error(`Error fetching executive actions for bills:`, error);
      throw error
  }
};

export default fetchBillsWithExecutiveAction;
